import { FC, useEffect, useState } from "react";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import {
  formatDateText,
  getCurrentMonth,
  getCurrentYear,
  isMonthEnabled,
  isYearEnabled,
} from "../../../helpers/datetime";
import { months, monthShortName } from "../../../constants/calendar";
import CustomDropdown from "./calender-dropdown";

const CalendarMonthWidget: FC<{
  fromDate: string;
  onSelecteMonth: (date: string) => void;
}> = ({ fromDate, onSelecteMonth }) => {
  const [selectedMonth, setSelectedMonth] = useState(
    months[getCurrentMonth(fromDate)]
  );
  const [selectedYear, setSelectedYear] = useState(getCurrentYear(fromDate));
  const [monthYear, setMonthYear] = useState(getCurrentYear());

  const onBack = () => {
    setSelectedYear(selectedYear - 1);
  };

  const onForward = () => {
    if (isYearEnabled(selectedYear)) {
      setSelectedYear(selectedYear + 1);
    }
  };

  const _getYears = () => {
    let yearsList = Array.from(
      { length: getCurrentYear() - 2021 },
      (_, i) => getCurrentYear() - i
    );
    return yearsList;
  };

  return (
    <div className="w-[70%] mx-auto">
      <div className={"flex items-center justify-center px-5 py-3"}>
        {/* Will Enable If required */}
        {/* <span
                        className={`cursor-pointer`}
                        onClick={onBack}
                    >
                        <BsChevronLeft />
                    </span>
                    <span
                        className="grow font-semibold text-center mx-2"
                        style={{ fontSize: "20px", color: "var(--ono-blue)" }}
                    >
                        {selectedYear}
                    </span>
                    <span
                        className={`${isYearEnabled(selectedYear) ? 'cursor-pointer' : 'color-sub-text'}`}
                        onClick={onForward}
                    >
                        <BsChevronRight />
                    </span> */}
        <div className="w-[100px]">
          <CustomDropdown
            label=""
            options={_getYears()}
            value=""
            onChange={(y: number) => {
              let month = months.findIndex((month) => month == selectedMonth);
              let date = new Date(y, month, 1);
              let formattedDate = formatDateText(date);
              onSelecteMonth(formattedDate);
              setMonthYear(y);
              setSelectedYear(y);
            }}
            placeholder={selectedYear}
            className="p-2"
            isList={true}
            ulHeight={"h-[250px] overflow-y-auto"}
            valueColor="color-blue"
          />
        </div>
      </div>
      <div className={`grid grid-cols-3 mt-2 text-center fs-14`}>
        {months.map((month, i) => (
          <div
            key={i}
            className={`flex items-center justify-center m-2 
                                ${
                                  isMonthEnabled(i) ||
                                  isYearEnabled(selectedYear)
                                    ? "cursor-pointer"
                                    : "color-sub-text"
                                }  
                            ${
                              selectedMonth == month &&
                              selectedYear == monthYear
                                ? "rounded-lg bg-primary p-2 text-white"
                                : ""
                            }`}
            onClick={() => {
              if (isMonthEnabled(i) || isYearEnabled(selectedYear)) {
                setSelectedMonth(month);
                const date = new Date(selectedYear, i, 1); // 1st day of the month
                onSelecteMonth(formatDateText(date));
                setMonthYear(selectedYear);
              }
            }}
          >
            {month}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CalendarMonthWidget;
